/**
 * Bug #1408 — shared contact text rules (mirrors backend ContactFieldRules HTML tag detection).
 */

/** Shown on first or last name fields when markup is detected. */
export const CONTACT_NAME_HTML_TAG_ERROR = "Names can't contain HTML tags.";

/** Shown on notes when markup is detected. */
export const CONTACT_NOTES_HTML_TAG_ERROR = "Notes can't contain HTML tags.";

/** Matches HTML open/close/self-closing tags (incl. slash-separated attrs); ASCII tag names only. */
const HTML_TAG_PATTERN = /<\/?\s*[A-Za-z][A-Za-z0-9_:-]*(?:[\s/][^>]*)?>/;

/**
 * Returns true when the value contains an HTML-like tag.
 */
export function containsHtmlTag(value: string | null | undefined): boolean {
  if (value == null || value.trim() === '') {
    return false;
  }

  return HTML_TAG_PATTERN.test(value);
}

/** Validates optional first name text (caller handles required / max length). */
export function validateContactFirstName(value: string): string | null {
  return containsHtmlTag(value) ? CONTACT_NAME_HTML_TAG_ERROR : null;
}

/** Validates optional last name text (caller handles required / max length). */
export function validateContactLastName(value: string): string | null {
  return containsHtmlTag(value) ? CONTACT_NAME_HTML_TAG_ERROR : null;
}

/** Validates optional notes (empty or omitted notes are allowed). */
export function validateContactNotes(value: string | null | undefined): string | null {
  return containsHtmlTag(value) ? CONTACT_NOTES_HTML_TAG_ERROR : null;
}
